import { render, staticRenderFns } from "./drag-drop-upload.modal.vue?vue&type=template&id=0a67193c&"
import script from "./drag-drop-upload.modal.vue?vue&type=script&lang=ts&"
export * from "./drag-drop-upload.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports